export default __webpack_public_path__ + "static/media/skin_deep.00a7cdc5.jpeg";